

































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {Helper} from 'simpli-web-sdk'
import moment from 'moment'
import {Responsavel} from '@/model/resource/Responsavel'
import {InputResponsavelSchema} from '@/schema/resource/Responsavel/InputResponsavelSchema'

@Component
export default class ModalUpdateActive extends Vue {
  model = new Responsavel()
  schema = new InputResponsavelSchema()

  openEvent(id?: number) {
    this.$emit('open')

    if (id) {
      this.model.getResponsavel(id)
    } else {
      this.close()
    }
  }

  closeEvent() {
    this.model.reset()
    this.$emit('close')
  }

  validate(date: string | null) {
    const d = moment(date ?? '')
    return moment(d).isValid()
  }

  async confirmEvent() {
    await this.model.updateAtivo(false)
    await Helper.success('system.success.persist')
    window.location.reload()
    this.close()
  }

  async cancelEvent() {
    this.$emit('cancel')
    this.close()
  }

  close() {
    this.$modal.close('updateActive')
    this.$tip.hideAll()
  }
}
